/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { EnrollmentAppStore } from "../redux/enrollment-store/store";
import { connect, Dispatch } from "react-redux";
import { EnrollmentPageProperties, EnrollmentsPage, EnrollmentPageDispatch } from "../pages/enrollments-page";
import { Environment } from "../utilities/environment";
import { BaseContainer } from "./base-container";
import { PaymentAndTaxStatus, Enrollment } from "../models/model";
import { ActionDispatcher, RemoveInvitationPayload } from "../redux/actions/actions";

function mapStateToProps(store: EnrollmentAppStore): EnrollmentPageProperties {
    return {
        fetchedData:
            store.dataFetchingStatus.bankAndTax &&
            store.dataFetchingStatus.enrollment &&
            store.dataFetchingStatus.metadata &&
            (!Environment.isModern() || true) &&
            (store.dataFetchingStatus.invitation),
        error:
            (store.dataFetchingStatus.enrollment && store.errorStatus.enrollment) ||
            (store.dataFetchingStatus.bankAndTax && store.errorStatus.bankAndTax) ||
            (store.dataFetchingStatus.metadata && store.errorStatus.metadata),
        hybridAccess: !BaseContainer.getEnrollmentDetails(store).every(x => x.accessViaLegacy == false),
        enrollments: BaseContainer.getEnrollmentDetails(store),
        canShowTable: store.dataFetchingStatus.enrollment && store.dataFetchingStatus.metadata,
        invitations: BaseContainer.getInvitationDetails(store),
        canShowWobo: (store.dataFetchingStatus.invitation || store.dataFetchingStatus.enrollment)
    };
}

const mapDispatchToProps = (dispatch: Dispatch<EnrollmentPageDispatch>) => {
    return {
        addEnrollment: (enrollment: Enrollment) => {
            dispatch(ActionDispatcher.addEnrollment(enrollment));
        },
        removeInvite: (invite: RemoveInvitationPayload) => {
            dispatch(ActionDispatcher.removeInvitation(invite));
        },
        updateBankAndTaxStatus: (bankAndTaxStatus: PaymentAndTaxStatus) => {
            dispatch(ActionDispatcher.updateBankAndTaxStatus(bankAndTaxStatus));
        }
    };
};
export const EnrollmentsPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(EnrollmentsPage);
